
// import React, { useContext, useEffect, useState } from "react";
// import { MyContext } from "../../../context/MyContext";
// import { useParams } from "react-router-dom";
// import DOMPurify from "dompurify";
// import axios from "axios";

// const OrderDetail = () => {
//   const { API_BASE_URL } = useContext(MyContext);
//   const { id } = useParams();
//   const [orderItems, setOrderItems] = useState([]);
//   const [products, setProducts] = useState([]);
//   const [userAddress, setUserAddress] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [description,setDescription]=useState("");

//   useEffect(() => {
//     axios
//       .get(`https://api.ourmicrolife.com/api/user/order/${id}`)
//       .then((response) => {
//         console.log(response)

//         setOrderItems(response?.data?.orderItems || []);
//          const sanitizedDescription = DOMPurify.sanitize();
//         setUserAddress(response?.data?.userAddress || null);
//         setProducts(response?.data?.products || []);
//         setDescription(description.slice(0, 200).split("\n")[0])
//         setLoading(false);
//       })
//       .catch(() => {
//         setError("Failed to fetch order details");
//         setLoading(false);
//       });
//   }, [id, API_BASE_URL]);

//   const handleCancelOrder = () => {
//     if (window.confirm("Are you sure you want to cancel this order?")) {
//       axios
//         .put(`https://api.ourmicrolife.com/api/user/order/${orderItems[0]?.id}`)
//         .then((result) => {
//           console.log(result);
//           alert("Order cancel successfully...");
//         })
//         .catch((error) => {
//           console.log(error);
//           alert("Error while canceling order.");
//         });
//     }
//   };

//   if (loading) {
//     return <div className="text-center text-gray-500">Loading...</div>;
//   }

//   if (error) {
//     return <div className="text-center text-red-500">{error}</div>;
//   }

//   return (
//     <div className="max-w-5xl mx-auto bg-white shadow-lg rounded-lg border border-violet-300 pt-4 md:pt-2 lg:pt-40">
//       <h2 className="text-3xl font-bold text-violet-700 mb-6 text-center">
//         Order Details
//       </h2>

//       {/* Product Details */}
//       <div className="py-5">
//         <h3 className="text-xl font-semibold text-violet-700 mb-2">
//           Product Details
//         </h3>
//         <ul className="grid grid-cols-1 md:grid-cols-2 gap-6">
//           {orderItems.map((product) => (
//             <li
//               key={product.id}
//               className="border p-4 rounded-lg shadow-md bg-violet-50"
//             >
//               <img
//                 src={`${product.product_image}`}
//                 alt={product.name}
//                 className="w-full h-48 object-cover rounded-md"
//               />
//               <div className="mt-3">
//                 <p className="font-bold text-violet-900">{product.productName}</p>
//                 {/* <div className="text-sm text-gray-600"   dangerouslySetInnerHTML={{ __html: `${description}......` }}>
            
//                 </div> */}
//                 {/* <p>
//                   <strong>Brand:</strong> {product.brand_name}
//                 </p> */}
//                 <p>
//                   <strong>Stock:</strong> {product.quantity} available
//                 </p>
//                 <p>
//                   <strong>Coins:</strong> {product.coins}
//                 </p>
//               </div>
//             </li>
//           ))}
//         </ul>
//       </div>

//       {/* Order Items */}
//       <div className="py-5">
//         <h3 className="text-xl font-semibold text-violet-700 mb-2">
//           Order Items
//         </h3>
//         <ul className="grid grid-cols-1 md:grid-cols-2 gap-6">
//           {orderItems.map((item) => (
//             <li
//               key={item.id}
//               className="border p-4 rounded-lg shadow-md bg-white"
//             >
//               <p>
//                 <strong>Size:</strong> {item.size}
//               </p>
//               <p>
//                 <strong>Color:</strong> {item.color}
//               </p>
//               <p>
//                 <strong>Quantity:</strong> {item.quantity}
//               </p>
//               <p>
//                 <strong>Price:</strong> ₹{item.total_price}
//               </p>
//             </li>
//           ))}
//         </ul>
//       </div>

//       {/* Shipping Address */}
//       {userAddress && (
//         <div className="py-5 border-t pt-4">
//           <h3 className="text-xl font-semibold text-violet-700 mb-2">
//             Shipping Address
//           </h3>
//           <div className="p-4 rounded-lg bg-violet-50 shadow-md">
//             <p>
//               <strong>Name:</strong> {userAddress.full_name}
//             </p>
//             <p>
//               <strong>Mobile:</strong> {userAddress.mobile_number}
//             </p>
//             <p>
//               <strong>Address:</strong> {userAddress.full_address}
//             </p>
//             <p>
//               <strong>City:</strong> {userAddress.city}, {userAddress.state} -{" "}
//               {userAddress.pin_code}
//             </p>
//             <p>
//               <strong>Nearby:</strong> {userAddress.near_by_address}
//             </p>
//           </div>
//         </div>
//       )}

//       {/* Cancel Order Button */}
//       <div className="flex justify-center mt-6">
//         {orderItems[0].status === "canceled" ? (
//           <div className="text-xl text-red-500">
//             You have canceled this order.
//           </div>
//         ) : (
//           <button
//             onClick={handleCancelOrder}
//             className="px-6 py-2 bg-red-600 text-white font-semibold rounded-lg hover:bg-red-700 transition-all"
//           >
//             Cancel Order
//           </button>
//         )}
//       </div>
//     </div>
//   );
// };

// export default OrderDetail;


import React, { useContext, useEffect, useState } from "react";
import { MyContext } from "../../../context/MyContext";
import { useParams } from "react-router-dom";
import DOMPurify from "dompurify";
import axios from "axios";
import { AiOutlineShoppingCart } from "react-icons/ai";  // Added an example icon

const OrderDetail = () => {
  const { API_BASE_URL } = useContext(MyContext);
  const { id } = useParams();
  const [orderItems, setOrderItems] = useState([]);
  const [products, setProducts] = useState([]);
  const [userAddress, setUserAddress] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [description, setDescription] = useState("");

  useEffect(() => {
    axios
      .get(`https://api.ourmicrolife.com/api/user/order/${id}`)
      .then((response) => {
        console.log(response);
        setOrderItems(response?.data?.orderItems || []);
        const sanitizedDescription = DOMPurify.sanitize(response?.data?.description || "");
        setUserAddress(response?.data?.userAddress || null);
        setProducts(response?.data?.products || []);
        setDescription(sanitizedDescription.slice(0, 200).split("\n")[0]);
        setLoading(false);
      })
      .catch(() => {
        setError("Failed to fetch order details");
        setLoading(false);
      });
  }, [id, API_BASE_URL]);

  const handleCancelOrder = () => {
    if (window.confirm("Are you sure you want to cancel this order?")) {
      axios
        .put(`https://api.ourmicrolife.com/api/user/order/${orderItems[0]?.id}`)
        .then((result) => {
          console.log(result);
          alert("Order canceled successfully...");
        })
        .catch((error) => {
          console.log(error);
          alert("Error while canceling order.");
        });
    }
  };

  if (loading) {
    return <div className="text-center text-gray-500 text-xl">Loading...</div>;
  }

  if (error) {
    return <div className="text-center text-red-500 text-xl">{error}</div>;
  }

  return (
    <div className="max-w-5xl mx-auto bg-white shadow-lg rounded-lg border border-violet-300 pt-6 pb-8">
      <h2 className="text-3xl font-bold text-violet-800 mb-8 text-center">
        Order Details
      </h2>

      {/* Product Details */}
      <div className="py-6 px-4">
        <h3 className="text-xl font-semibold text-violet-700 mb-4">
          Product Details
        </h3>
        <ul className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {orderItems.map((product) => (
            <li key={product.id} className="border p-6 rounded-lg shadow-xl bg-violet-50 hover:shadow-2xl transition-all">
              <img
                src={`${product.product_image}`}
                alt={product.name}
                className="w-full h-56 object-cover rounded-md mb-4"
              />
              <div className="mt-3">
                <p className="font-bold text-violet-900 text-lg">{product.productName}</p>
                <p className="text-gray-700 mt-2">
                  <strong>Stock:</strong> {product.quantity} available
                </p>
                <p className="text-gray-700">
                  <strong>Coins:</strong> {product.coins}
                </p>
              </div>
            </li>
          ))}
        </ul>
      </div>

      {/* Order Items */}
      <div className="py-6 px-4">
        <h3 className="text-xl font-semibold text-violet-700 mb-4">Order Items</h3>
        <ul className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {orderItems.map((item) => (
            <li key={item.id} className="border p-6 rounded-lg shadow-xl bg-white hover:shadow-2xl transition-all">
              <p>
                <strong>Size:</strong> {item.size}
              </p>
              <p>
                <strong>Color:</strong> {item.color}
              </p>
              <p>
                <strong>Quantity:</strong> {item.quantity}
              </p>
              <p>
                <strong>Price:</strong> ₹{item.total_price}
              </p>
            </li>
          ))}
        </ul>
      </div>

      {/* Shipping Address */}
      {userAddress && (
        <div className="py-6 px-4 border-t pt-6">
          <h3 className="text-xl font-semibold text-violet-700 mb-4">
            Shipping Address
          </h3>
          <div className="p-6 rounded-lg bg-violet-50 shadow-xl">
            <p>
              <strong>Name:</strong> {userAddress.full_name}
            </p>
            <p>
              <strong>Mobile:</strong> {userAddress.mobile_number}
            </p>
            <p>
              <strong>Address:</strong> {userAddress.full_address}
            </p>
            <p>
              <strong>City:</strong> {userAddress.city}, {userAddress.state} -{" "}
              {userAddress.pin_code}
            </p>
            <p>
              <strong>Nearby:</strong> {userAddress.near_by_address}
            </p>
          </div>
        </div>
      )}

      {/* Cancel Order Button */}
      <div className="flex justify-center mt-8">
        {orderItems[0].status === "canceled" ? (
          <div className="text-xl text-red-500">You have canceled this order.</div>
        ) : (
          <button
            onClick={handleCancelOrder}
            className="px-8 py-3 bg-red-600 text-white font-semibold rounded-lg hover:bg-red-700 transition-all"
          >
            <AiOutlineShoppingCart className="inline-block mr-2" />
            Cancel Order
          </button>
        )}
      </div>
    </div>
  );
};

export default OrderDetail;
